import { Sidebar, SidebarProps } from '@payaca/ambrosia';
import { FC, type JSX } from 'react';
import ScheduledEventReadView from '../scheduledEventReadView/ScheduledEventReadView';
import './ScheduledEventReadDrawer.sass';

type Props = {
  scheduledEventId?: number;
  hideDealLink?: boolean;
  onDeleteScheduledEventSuccess?: () => void;
  onUpdateScheduledEventSuccess?: () => void;
  onUpdateTasksSuccess?: () => void;
  isOpen: boolean;
  onClose?: () => void;
  hideNotes?: boolean;
  zIndexLevel?: SidebarProps['zIndexLevel'];
};

const ScheduledEventReadDrawer: FC<Props> = ({
  scheduledEventId,
  hideDealLink,
  onDeleteScheduledEventSuccess,
  onUpdateScheduledEventSuccess,
  onUpdateTasksSuccess,
  isOpen,
  onClose,
  hideNotes,
  zIndexLevel,
}: Props): JSX.Element | null => {
  return (
    <Sidebar
      isOpen={isOpen}
      onClose={onClose}
      className="scheduled-event-read-drawer"
      zIndexLevel={zIndexLevel}
    >
      <Sidebar.Body className="flex flex-col p-4">
        {scheduledEventId && (
          <ScheduledEventReadView
            scheduledEventId={scheduledEventId}
            hideDealLink={hideDealLink}
            hideNotes={hideNotes}
            onDeleteScheduledEventSuccess={() => {
              onClose?.();
              onDeleteScheduledEventSuccess?.();
            }}
            onUpdateScheduledEventSuccess={onUpdateScheduledEventSuccess}
            onUpdateTasksSuccess={onUpdateTasksSuccess}
          />
        )}
      </Sidebar.Body>
    </Sidebar>
  );
};
export default ScheduledEventReadDrawer;
